module.exports = __webpack_public_path__ + "img/repeat-dark.c569dc9c.svg";